const MOVED_OUT_MARKER = '[batch change] moved to';

export function isMovedOutEnrollment(enrollment) {
  return String(enrollment?.remarks || '').toLowerCase().includes(MOVED_OUT_MARKER);
}

export function currentEnrollmentCount(batch) {
  return (batch?.enrollments || []).filter((row) => !isMovedOutEnrollment(row)).length;
}
